/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './custom-event-edit-page.component.html';
import {SignalAdminResourceEditPageBase} from '../../common/controller/signal-admin-resource-edit-page-base';
import {CustomEventApiService, CustomEventModel} from './custom-event-api.service';
import {CUSTOM_EVENT_CONVERSION_TYPES, CustomEventConversionType} from './custom-event-commons';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {APP_SHARED} from '../../common/app-shared';
import {CustomEventConversionTypeDescriptionComponent} from './custom-event-conversion-type-description-component';
import {CustomEventExampleCodeComponent} from './custom-event-example-code-component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule, TranslateModule, ButtonsModule, CustomEventConversionTypeDescriptionComponent, CustomEventExampleCodeComponent],
  selector: 'adn-custom-event-edit-page',
  template
})
export class CustomEventEditPageComponent extends SignalAdminResourceEditPageBase<CustomEventModel> {
  readonly conversionTypes: CustomEventConversionType[] = CUSTOM_EVENT_CONVERSION_TYPES;

  constructor(api: CustomEventApiService) {
    super(api, 'customEvent');
  }

  protected override initialiseModel(model: CustomEventModel): CustomEventModel {
    return {
      ...super.initialiseModel(model),
      conversionType: model.conversionType === undefined ? null : model.conversionType,
      type: model.type || 'COUNT'
    };
  }
}
